// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3-tbd","header":"MergedInvoice_header__17pgY"};